import imgProfile from "../img/profile.ico";
export const playlistSetMax = 10;
// export const nightTheme = {
//   "--main-back": "#000000",
//   "--main-color": "#ffffff",
//   "--main-color-int": "#1db3b3",
//   "--wrap-back": "#1d1b1b",
//   "--wrap-color": "#0f9393b3",
//   "--wrap-color-int": "#808080",
//   "--background-first": "#1d2225",
//   "--background-second": "#0e4949",
//   "--background-nav": "#011e16",
//   "--background-note": "#1f4f5c",
//   "--background-parts-answ": "#142525b3", // "#0f9393b3",
//   "--border-fill": "#DADEE8",

//   "--color-checked": "#0f9393b3",
//   "--color-rate": "#1db3b3",
//   "--color-second": "#b5a68a",
//   "--wrap-opacity": "0",
//   "--shadow-size": "-1px",
//   // "--color-menuG": "#1db3b3",
//   // "--back-menu": "#0f9393b3",
//   // "--background-even": "#1e282e",
//   // "--background-header": "#252c2f",
//   // "--background-second": "#252c2f",

//   // "--background-wrap-rgb": "rgb(29, 27, 27, 0)",
//   // "--color-about": "#128867",
//   // "--wrap-color": "#86909b",
//   // // "--color-nav": "#0f9393b3",
//   // "--white-black": "#e9e8e6",
// };

// export const dayTheme = {
//   // "--back-menu": "#2a313e",
//   // "--background-even": "#F7F6F6",
//   // "--background-header": "#f7f6f6",
//   // "--background-second": "#ededed",
//   // "--background-wrap-rgb": "rgb(252, 252, 252)",
//   // "--color-about": "#5d8fd0",
//   // "--wrap-color": "#5f6368",
//   // "--color-nav": "#343f59",
//   // "--white-black": "#5f6368",
//   // "--wrap-opacity": "0",

//   "--main-back": "#ffffff",
//   "--main-color": "#000000",
//   "--main-color-int": "#597db4",
//   "--wrap-back": "#ffffff",
//   "--wrap-color": "#343f59",
//   "--wrap-color-int": "#0A58CA",
//   "--background-first": "#fcfbf7",
//   "--background-second": "#EDEFF4",
//   "--background-nav": "#5c8ece",
//   "--background-note": "#5c8ece",
//   "--background-parts-answ": "#ffebcd",
//   "--border-fill": "#DADEE8",

//   "--color-checked": "#ed666d",
//   "--color-rate": "#64b5f6",
//   "--color-second": "#000000",
//   "--shadow-size": "6px",
//   // "--color-menuG": "#5f6368",
// };
// export const dayTheme1 = {
//   // "--back-menu": "#2a313e",
//   // "--background-even": "#F7F6F6",
//   // "--background-header": "#f7f6f6",
//   // "--background-second": "#ededed",
//   // "--background-wrap-rgb": "rgb(252, 252, 252)",
//   // "--color-about": "#5d8fd0",
//   // "--wrap-color": "#5f6368",
//   // "--color-nav": "#343f59",
//   // "--white-black": "#5f6368",
//   // "--wrap-opacity": "0",

//   "--main-back": "#e9e8e6",
//   "--main-color": "#000000",
//   "--main-color-int": "#597db4",
//   "--wrap-back": "#ffffff",
//   "--wrap-color": "#343f59",
//   "--wrap-color-int": "#0A58CA",
//   "--background-first": "#fcfbf7",
//   "--background-second": "#EDEFF4",
//   "--background-nav": "#343f59",
//   "--background-note": "#5c8ece",
//   "--background-parts-answ": "#ffebcd",
//   "--border-fill": "#DADEE8",

//   "--color-checked": "#ed666d",
//   "--color-rate": "#64b5f6",
//   "--color-second": "#000000",
//   "--shadow-size": "6px",
//   // "--color-menuG": "#5f6368",
// };
// export const defaultColorBack = "#ffffff";
// export const defaultStyleValue = {
//   colorBack: dayTheme["--main-back"],
//   colorBackN: nightTheme["--main-back"],
//   wrapOpacity: 100,
// };
export const defaultSettings = {};
export const defaultAvatar = imgProfile;
export const DEFAUL_USER_DATA = {
  name: "",
  email: "",
  img: defaultAvatar,
  password: "",
  settings: defaultSettings,
};
export const defRatesSel = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
};
export const themeArr = {
  day: {
    isday: true,
    "--main-back": "#ffffff",
    "--main-color": "#000000",
    "--main-color-int": "#597db4",
    "--wrap-back": "#ffffff",
    "--wrap-color": "#343f59",
    "--wrap-color-int": "#0A58CA",
    "--background-first": "#fcfbf7",
    "--background-second": "#EDEFF4",
    "--background-nav": "#5c8ece",
    "--background-note": "#5c8ece",
    "--background-parts-answ": "#ffebcd",
    "--border-fill": "#DADEE8",

    "--color-nav": "#ffffff",
    "--color-checked": "#ed666d",
    "--color-rate": "#64b5f6",
    "--color-second": "#000000",
    "--shadow-size": "6px",
  },

  night: {
    isday: false,
    "--main-back": "#000000",
    "--main-color": "#ffffff",
    "--main-color-int": "#b1c9ec",
    "--wrap-back": "#1d1b1b",
    "--wrap-color": "#768ec6",
    "--wrap-color-int": "#1f8ac8b3",
    "--background-first": "#0d121d",
    "--background-second": "#212837",
    "--background-nav": "#343f59",
    "--background-note": "#1f4f5c",
    "--background-parts-answ": "#111728b3", // "#0f9393b3",
    "--border-fill": "#DADEE8",

    "--color-nav": "#a6bdde",
    "--color-checked": "#cae5ffb3",
    "--color-rate": "#48556b",
    "--color-second": "#5f7098",
    "--wrap-opacity": "0",
    "--shadow-size": "-1px",
  },

  jade: {
    isday: false,
    "--main-back": "#000000",
    "--main-color": "#ffffff",
    "--main-color-int": "#1db3b3",
    "--wrap-back": "#1d1b1b",
    "--wrap-color": "#0f9393b3",
    "--wrap-color-int": "#808080",
    "--background-first": "#1d2225",
    "--background-second": "#0e4949",
    "--background-nav": "#011e16",
    "--background-note": "#1f4f5c",
    "--background-parts-answ": "#142525b3", // "#0f9393b3",
    "--border-fill": "#DADEE8",

    "--color-nav": "#1db3b3",
    "--color-checked": "#0f9393b3",
    "--color-rate": "#1db3b3",
    "--color-second": "#b5a68a",
    "--wrap-opacity": "0",
    "--shadow-size": "-1px",
  },
  rain: {
    isday: true,
    "--main-back": "#d7e0eb",
    "--main-color": "#000000",
    "--main-color-int": "#597db4",
    "--wrap-back": "#ffffff",
    "--wrap-color": "#343f59",
    "--wrap-color-int": "#597db4",
    "--background-first": "#fcfbf7",
    "--background-second": "#EDEFF4",
    "--background-nav": "#343f59",
    "--background-note": "#536389",
    "--background-parts-answ": "#c8e1ff",
    "--border-fill": "#aab0be",
    "--color-nav": "white",
    "--color-checked": "#ed666d",
    "--color-rate": "#64b5f6",
    "--color-second": "#000000",
    "--shadow-size": "6px",
  },
  grey: {
    isday: true,
    "--main-back": "#dad7d2",
    "--main-color": "#000000",
    "--main-color-int": "#8592ae",
    "--wrap-back": "#e9e6df",
    "--wrap-color": "#343f59",
    "--wrap-color-int": "#bbcada",
    "--background-first": "#e2e1dd",
    "--background-second": "#d4d0c9",
    "--background-nav": "#9ca4ac",
    "--background-note": "#666a6d",
    "--background-parts-answ": "#c4baa9",
    "--border-fill": "#aab0be",

    "--color-nav": "#393939",
    "--color-checked": "#ed666d",
    "--color-rate": "#979797",
    "--color-second": "#000000",
    "--shadow-size": "6px",
  },
};
